import RoutesUtils from './../../js/RoutesUtils.js';

/**
 * Quién puede entrar al calendario. Una sola lista, que usan sus dos rutas y cualquier pantalla
 * que enlace con él, para que la ruta y el enlace no respondan cosas distintas.
 *
 * El precedente y el porqué están en `src/pages/empleados/permisos.js`: cuatro copias de la misma
 * lista contestaban distinto y el enlace llevaba a un 403.
 */
export const ROLES_CALENDARIO = ['ADMIN', 'INSPECTOR'];

/**
 * ¿Puede esta persona abrir el calendario de `username`?
 *
 * **Manda el menú de Mongo, no el rol**: `RoutesUtils.tieneAcceso` solo cae en la lista de roles
 * mientras el menú no esté cargado, así que tener el rol INSPECTOR no basta si `/calendario/` no
 * cuelga de su menú — que es justo el caso que produce el 403 (`CLAUDE.md` §9 del orquestador).
 *
 * Lo usa el aviso de planificaciones abiertas de la #425: si devuelve `false`, el aviso NO pinta
 * el enlace y dice que esa corrección la tiene que hacer quien sí tenga el calendario.
 */
export function puedeAbrirCalendario(username) {
    return RoutesUtils.tieneAcceso(rutaCalendario(username), ROLES_CALENDARIO);
}

/** La ruta del calendario de una persona; sin persona, el calendario propio. */
export function rutaCalendario(username) {
    return username ? '/calendario/' + username + '/' : '/calendario/';
}

export default { ROLES_CALENDARIO, puedeAbrirCalendario, rutaCalendario };
